<!--header-right-->
<template>
  <div class="home-business-entry" :type="count === 1 ? 'EN' : 'CN'">
    <!-- 机票 -->
    <div class="item" v-if="hasPlaneTicketEntry" @click="$emit('gotoPage', 'plane')">
      <div class="logo" :style="{backgroundImage: `url(${getTheme('home:enter:icon-plane')})`}"></div>
      <div class="des">
        <span>{{$t('FlightTicket')}}</span>
        <span>{{details.FlightTitle}}</span>
      </div>
    </div>

    <!-- 酒店 -->
    <div class="item" v-if="hasHotelEntry" @click="$emit('gotoPage', 'hotel')">
      <div class="logo" :style="{backgroundImage: `url(${getTheme('home:enter:icon-hotel')})`}"></div>
      <div class="des">
        <span>{{$t('Hotel')}}</span>
        <span>{{details.HoteltTitle}}</span>
      </div>
    </div>

    <!-- 火车票 -->
    <div class="item" v-if="hasTrainEntry" @click="$emit('gotoPage', 'train')">
      <div class="logo" :style="{backgroundImage: `url(${getTheme('home:enter:icon-train')})`}"></div>
      <div class="des">
        <span>{{$t('TrainTicket')}}</span>
        <span>{{details.TrainTitle}}</span>
      </div>
    </div>

    <!-- 用车 -->
    <div class="item" v-if="hasCarEntry" @click="$emit('gotoPage', 'car')">
      <div class="logo" :style="{backgroundImage: `url(${getTheme('home:enter:icon-car')})`}"></div>
      <div class="des">
        <span>{{$t('Car')}}</span>
        <span>{{details.CarTitle}}</span>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    details: {
      type: Object,
      default: () => {
        return {}
      }
    },
    TravelType: {
      type: Number,
      default: 0
    },
    count: {
      type: Number,
      default: 0
    }
  },
  computed: {
    /** 机票入口 */
    hasPlaneTicketEntry() {
      let val = this.TravelType === 0 && (this.hasPower('因公:机票:国内机票查询') || this.hasPower('因公:机票:国际机票查询'))
      if (this.TravelType === 1) {
        val = this.hasPower('因私:国内机票') || this.hasPower('因私:国际机票')
      }
      return val
    },
    /** 酒店入口 */
    hasHotelEntry() {
      let val = this.TravelType === 0 && (this.hasPower('因公:酒店:国内酒店查询') || this.hasPower('因公:酒店:国际酒店查询'))
      if (this.TravelType === 1) {
        val = this.hasPower('因私:国内酒店') || this.hasPower('因私:国际酒店')
      }
      return val
    },
    /** 火车票入口 */
    hasTrainEntry() {
      let val = this.TravelType === 0 && this.hasPower('因公:火车票')
      if (this.TravelType === 1) {
        val = this.hasPower('因私:火车票')
      }
      return val
    },
    /** 用车入口 */
    hasCarEntry() {
      return (this.TravelType === 0 && this.hasPower('因公:用车'))
    },
  },
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
.home-business-entry
  @extend .flex-between
  background $color_black_0
  border-radius 12px
  margin-bottom 12px
  &[type='EN']
    flex-wrap wrap
    >.item
      @extend .flex-start
      flex-direction initial
      padding 11px 16px
      >.logo
        margin-right 12px
      >.des
        @extend .hs-font-subtitle-big
        color $color_black_900
        >span:nth-child(2)
          display block
  >.item
    @extend .flex-center
    flex-direction column
    width 100%
    padding 11px
    >.logo
      width 40px
      height 40px
      background-size 100% 100%
      background-repeat no-repeat
    >.des
      @extend .hs-font-caption-1
      color $color_black_600
      >span:nth-child(2)
        display none
        @extend .hs-font-caption-1
        color $color_black_100
</style>
